import React from "react";
import PropTypes from "prop-types";

const CannabisShowCaseLoading = ({ title }) => {
    return (
        <div className="cannabisbanner">
            <span>{title}</span>
        </div>
    );
};

CannabisShowCaseLoading.defaultProps = {
    title: "Cannabis Showcase"
};

CannabisShowCaseLoading.propTypes = {
    title: PropTypes.string
};

export default CannabisShowCaseLoading;
